<section class="schemas-page">
  <header class="page-header">
    <div class="page-header-text">
      <h1>Modelos de datos</h1>
      <p>Selecciona un modelo de datos para crear y validar archivos.</p>
    </div>
  </header>

  @if (isLoading) {
    <div class="table-wrap">
      <table class="schemas-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Estructura</th>
            <th class="col-updated">Última actualización</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (_ of [1,2,3,4,5]; track _) {
            <tr class="skeleton-row">
              <td><div class="skeleton-line" style="width:180px"></div></td>
              <td><div class="skeleton-line" style="width:70px"></div></td>
              <td class="col-updated"><div class="skeleton-line" style="width:100px"></div></td>
              <td><div class="skeleton-line" style="width:60px"></div></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else if (schemas.length) {
    <div class="table-toolbar">
      <div class="search-field">
        <mat-icon inline>search</mat-icon>
        <input
          type="text"
          placeholder="Buscar por nombre o descripción..."
          [(ngModel)]="searchText">
      </div>
    </div>

    @if (filteredSchemas.length) {
      <div class="table-wrap">
        <table class="schemas-table">
          <thead>
            <tr>
              <th class="sortable" (click)="setSort('name')">
                Nombre
                @if (sortColumn === 'name') {
                  <mat-icon inline class="sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                }
              </th>
              <th class="sortable" (click)="setSort('columns')">
                Estructura
                @if (sortColumn === 'columns') {
                  <mat-icon inline class="sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                }
              </th>
              <th class="sortable col-updated" (click)="setSort('updated_at')">
                Última actualización
                @if (sortColumn === 'updated_at') {
                  <mat-icon inline class="sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                }
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (item of filteredSchemas; track item.id) {
              <tr class="schema-row" (click)="openSchema(item)">
                <td class="col-name">
                  <span class="name-text">{{ item.name || 'Sin nombre' }}</span>
                  @if (item.description) {
                    <span class="desc-text">{{ item.description }}</span>
                  }
                </td>
                <td class="col-cols">
                  <div class="structure-summary">
                    <span class="cols-chip">{{ getColumnCount(item) }}</span>
                    <span class="structure-copy">
                      <strong>{{ getColumnCount(item) === 1 ? '1 columna' : getColumnCount(item) + ' columnas' }}</strong>
                      <small>{{ getRequiredColumnCount(item) }} obligatorias</small>
                    </span>
                  </div>
                </td>
                <td class="col-updated">
                  {{ formatUpdatedAt(item.updated_at) }}
                </td>
                <td class="col-action">
                  <button class="open-btn" (click)="openSchema(item); $event.stopPropagation()">
                    Importar <mat-icon inline>arrow_forward</mat-icon>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="status-empty status-empty-inline">
        <mat-icon class="status-icon">search_off</mat-icon>
        <h3>Sin resultados</h3>
        <p>No encontramos modelos de datos que coincidan con "{{ searchText }}".</p>
      </div>
    }
  } @else {
    <div class="status-empty">
      <mat-icon class="status-icon">schema</mat-icon>
      <h3>No tienes modelos de datos asignados</h3>
      <p>Cuando tengas permisos en un modelo de datos, aparecerá aquí para que puedas gestionarlo.</p>
    </div>
  }
</section>
